import React, { useState } from "react";
import { Accordion, Icon, Table, Label } from "semantic-ui-react";
import moment from "moment";
import displayName from "utils/displayName";

const AccordionRoads = ({ list, goToFolderManager }) => {
	const [activeIndex, setActiveIndex] = useState(-1);
	const handleClick = (e, titleProps) => {
		const { index } = titleProps;
		const newIndex = activeIndex === index ? -1 : index;
		setActiveIndex(newIndex);
	};
	return (
		<Accordion styled style={{ width: "100%", maxHeight: "calc(100vh - 170px)", overflowY: "auto", height: "fit-content" }}>
			{list.map((el, index) => (
				<div key={`road${index}`}>
					<Accordion.Title active={activeIndex === index} index={index} onClick={handleClick}>
						<Icon name="dropdown" />
						{el.label} : {el.roadAppointments.length} rendez-vous{" "}
						{el.nurseMyRdv && (
							<>
								{el.nurseMyRdv.network && <Label color="blue">Réseau : {el.nurseMyRdv.network.name}</Label>}
								<Label color="orange">
									Tournée assignée à {el.nurseMyRdv.name || ""} {el.nurseMyRdv.lastname || ""}
								</Label>
							</>
						)}
					</Accordion.Title>
					<Accordion.Content active={activeIndex === index}>
						<Table celled>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>Heure</Table.HeaderCell>

									<Table.HeaderCell>Adresse</Table.HeaderCell>
									<Table.HeaderCell>Patient</Table.HeaderCell>
									<Table.HeaderCell>Dossier</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{el.roadAppointments.map((appointment, index) => (
									<Table.Row key={`app-${index}`} style={{ backgroundColor: appointment.cancelled ? "lightgrey" : "white" }}>
										{!appointment.cancelled && <Table.Cell>{moment(`${appointment._date} ${appointment._time}`).format("HH:mm")}</Table.Cell>}
										{appointment.cancelled && (
											<Table.Cell>
												<s>{moment(`${appointment._date} ${appointment._time}`).format("HH:mm")}</s> - Annulé : {appointment.cancelled_comment}
											</Table.Cell>
										)}
										<Table.Cell>{appointment.address}</Table.Cell>
										<Table.Cell>
											{appointment.patient ? (
												<>
													<div>
														{displayName(appointment.patient)} (
														{appointment.patient.gender === "m" ? "M." : appointment.patient.gender === "f" ? "Mme" : ""})
													</div>
													{appointment.patient.cns ? <div> {appointment.patient.cns}</div> : ""}
													<div>
														{appointment.patient.birth_date
															? `${moment(appointment.patient.birth_date).format("DD/MM/YYYY")} (${moment().diff(
																	appointment.patient.birth_date,
																	"years"
															  )} ans)`
															: ""}
													</div>
												</>
											) : (
												appointment.mylabId
											)}
										</Table.Cell>

										<Table.Cell>
											{appointment.folder && (
												<Label
													as="a"
													onClick={() => {
														goToFolderManager(appointment.folder?.id);
													}}
												>
													{appointment.folder ? `Dossier ${appointment.folder?.code}` : "/"}
													<Label.Detail>
														{appointment.folder?.status}
														{appointment.folder?.json_generated &&
															appointment.folder?.json_generation_date &&
															` - Envoyé à Geslab le ${appointment.folder?.json_generation_date}`}
													</Label.Detail>
												</Label>
											)}
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>
					</Accordion.Content>
				</div>
			))}
		</Accordion>
	);
};

export default AccordionRoads;
